import { styled } from "@mui/material/styles";
import { Menu, MenuItem, TableCell, TableRow } from "@mui/material";

export const CustomMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    // backgroundColor: red[500],
    backgroundColor: theme.palette.customColors.white,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[0],
    fontSize: "0.8rem",
  },
  "& .MuiList-root": {
    backgroundColor: theme.palette.customColors.white,
  },
  "& .MuiListItem-root": {
    backgroundColor: theme.palette.customColors.white,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.primary.main,
    },
  },
}));

export const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: "0.6rem",
  backgroundColor: theme.palette.customColors.white,
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.primary.main,
    fontSize: "0.9rem",
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: "bold",
  whiteSpace: "nowrap",
  borderBottom: "1px solid #E2E2E2",
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  borderBottom: "1px solid #E2E2E2",
  "&:nth-of-type(odd)": {
    // backgroundColor: theme.palette.action.hover,
  },
  "&:hover": {
    backgroundColor: theme.palette.action.selected,
  },
}));
